






















import Vue from "vue";
import { Prop } from "vue-property-decorator";
import { Component } from "vue-mixin-decorator";
import moment from "moment/moment";
import { ChatInfo, GroupChatTabInfo, UserData } from "@/@types/room";
import { StoreUseData } from "@/@types/store";
import { permissionCheck } from "@/app/core/api/app-server/SocketFacade";
import { transText } from "@/app/core/utility/ChatUtility";
import { ActorStore } from "@/@types/gameObject";
import TabsComponent from "@/app/basic/common/components/tab-component/TabsComponent.vue";
import { UserType } from "@/@types/socket";
import VueEvent from "@/app/core/decorator/VueEvent";

@Component({
  components: { TabsComponent }
})
export default class ChatLogLineComponent extends Vue {
  @Prop({ type: Object, required: true })
  private chat!: StoreUseData<ChatInfo>;

  @Prop({ type: String, required: true })
  private editedMessage!: string;

  @Prop({ type: Array, required: true })
  private userList!: StoreUseData<UserData>[];

  @Prop({ type: Array, required: true })
  private actorList!: StoreUseData<ActorStore>[];

  @Prop({ type: Array, required: true })
  private groupChatTabList!: StoreUseData<GroupChatTabInfo>[];

  @Prop({ type: Object, required: true })
  private userTypeLanguageMap!: { [type in UserType]: string };

  @VueEvent
  private isEditable(chat: StoreUseData<ChatInfo>): boolean {
    return permissionCheck(chat, "edit");
  }

  private get isEdited(): boolean {
    return this.chat.updateTime !== this.chat.createTime;
  }

  @VueEvent
  private getDateStr(d: Date) {
    return moment(d).format("YYYY/MM/DD HH:mm:ss");
  }

  @VueEvent
  private getSender(chat: ChatInfo): string {
    const actorName = this.getName(chat.actorId, "actor");
    const delimiter = " ＞＞ ";
    const targetName = this.getName(chat.targetId, chat.targetType);
    return actorName + (targetName ? delimiter + targetName : "");
  }

  private getName(id: string, type: "group" | "actor") {
    if (type === "group") {
      const gct = this.groupChatTabList.filter(gct => gct.id === id)[0];
      if (gct.data!.isSystem) return "";
      return gct.data!.name;
    } else {
      const actor = this.actorList.filter(a => a.id === id)[0];
      const user = this.userList.filter(u => u.id === actor.owner)[0];
      const userType = this.userTypeLanguageMap[user.data!.type];
      const userTypeStr = actor.data!.type !== "user" ? "" : `(${userType})`;
      return `${actor.data!.name}${userTypeStr}`;
    }
  }

  @VueEvent
  private transText(raw: string): string {
    return transText(raw);
  }
}
